"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Used to submit a grade for a single student all students
class SubmitGradeParams {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }
        else {
            this.lineItemId = "assignmentId";
            this.scoreGiven = 100;
            this.userId = "selectValue";
            this.comment = "Instructor comment on the student performance";
            this.activityProgress = "Completed";
            this.gradingProgress = "FullyGraded";
            this.scoreMaximum = 100;
            this.timestamp = new Date(Date.now()).toISOString();
        }
    }
}
exports.default = SubmitGradeParams;
